import { render } from "./BackGroundBox.vue?vue&type=template&id=6e3be3e0"
import script from "./BackGroundBox.vue?vue&type=script&lang=js"
export * from "./BackGroundBox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__